import { render, staticRenderFns } from "./OutputAnalysisOfData.vue?vue&type=template&id=522f6420&scoped=true"
import script from "./OutputAnalysisOfData.vue?vue&type=script&lang=js"
export * from "./OutputAnalysisOfData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522f6420",
  null
  
)

export default component.exports